import { ResponseWithFieldErrorFragment } from '../graphql/generated'

export function isResponseWithFieldError(
  val:
    | ({
        __typename?: 'ResponseWithFieldError'
      } & ResponseWithFieldErrorFragment)
    | { __typename?: string }
    | undefined,
): val is ResponseWithFieldErrorFragment {
  return !!val && val['__typename'] === 'ResponseWithFieldError'
}
